import { Autocomplete, FormHelperText, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'

interface AutocompleteBrandLinesProps {
  vipContentState: any
  handleInputChange: any
  tmpBrandLines: any
}

export function AutocompleteBrandLinesVip({ vipContentState, handleInputChange, tmpBrandLines }: AutocompleteBrandLinesProps) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleAutoCompleteChange = (value: any) => {
    let optionsMulti = []
    if (value !== null) {
      for (let i = 0; i < value.length; i++) {
        optionsMulti.push(value[i].pivot.id)
      }
    }

    handleInputChange('line_ids', optionsMulti)
  }

  return (
    <>
      <Autocomplete
        id="autocomplete-brandlines-vip"
        value={tmpBrandLines.filter((brandline: any) => vipContentState.line_ids.includes(brandline.pivot.id))}
        onChange={(_, value) => handleAutoCompleteChange(value)}
        options={tmpBrandLines}
        multiple
        getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
        renderInput={params => <TextField required {...params} label={t('lines')} variant="filled" InputLabelProps={{ shrink: true }} />}
      />
      <FormHelperText error={errorForm.lines}>{msgForm.lines}</FormHelperText>
    </>
  )
}
